import { Checkbox, Chip, Divider, FormControlLabel, Grid, IconButton, Stack, Switch, TextField, Typography } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import ArrowRightIcon from '@mui/icons-material/ArrowForward';
import { SelectPeriodoVendasValues } from "../../../../../../components/SelectPeriodoSazonal";
import useDebounce from "../../../../../../lib/useDebounce";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import SelectPeriodoSazonal from "../../../../../../components/SelectPeriodoSazonal";
import SelectQuery from "../../../../../../components/SelectQuery";
import ModalOrigemDestino from "./ModalOrigemDestino";
import ModalSelectQtdSugestion from "./ModalSelectQtdSugestion";
import { AuthContext } from "../../../../../../contexts/AuthContext";
import { FiltrosPreDefinidos, IFilters } from "../..";
import { filtrosPreDefinidos } from "./filtrosPredefinidos";
import { Box } from "@mui/system";

export default function Filtros({ values, onChange = () => { } }: FiltrosProps) {

    const { userPerfilComLoja } = useContext(AuthContext);

    const [searchTerm, setSearchTerm] = useState<string>("");
    const [openSelectModal, setOpenSelectModal] = useState(false)
    const [openModalQtdSugestion, setOpenModalQtdSugestion] = useState(false)

    const debouncedSearchTerm = useDebounce(searchTerm);

    const niveisEstoqueOptions = useMemo(() => [
        { value: "0a15", label: "0 a 15 dias" },
        { value: "16a30", label: "16 a 30 dias" },
        { value: "31a60", label: "31 a 60 dias" },
        { value: "60mais", label: "> 60 dias" }
    ], [])

    // Funções Manipuladoras
    const handleOpenSelectModal = useCallback(() => {
        setOpenSelectModal(true)
    }, [])

    const handleSelectPreFilter = useCallback((itemSelecionado: FiltrosPreDefinidos) => {
        onChange({
            predSelecionado: itemSelecionado,
            departamentos: itemSelecionado.filtros.departamentos,
            origem: itemSelecionado.filtros.origem
        })
    }, [onChange])

    const handleSelectNiveisEstoque = useCallback((value: string) => {
        const niveisEstq = [...values.niveis_estoque]

        const index = niveisEstq.indexOf(value);
        if (index !== -1) niveisEstq.splice(index, 1);
        if (index === -1) niveisEstq.push(value);

        onChange({
            niveis_estoque: niveisEstq
        })
    }, [values.niveis_estoque, onChange])
    //

    useEffect(() => {
        if (userPerfilComLoja?.loja && values.destino == null && values.origem == null) {
            setOpenSelectModal(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values.destino, values.origem])

    useEffect(() => {
        onChange({ pesquisar: debouncedSearchTerm });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedSearchTerm]);

    return (
        <>
            <Grid container justifyContent="space-between" p={1} mt={4}>

                <Grid display="flex" alignItems="center">
                    <div>
                        <Typography fontSize={12}>Origem</Typography>
                        <Typography fontSize={18}>{values.origem?.nome || "-"}</Typography>
                    </div>
                    <ArrowRightIcon style={{ margin: 12 }} />
                    <div>
                        <Typography fontSize={12}>Destino</Typography>
                        <Typography fontSize={18}>{values.destino?.nome || "-"}</Typography>
                    </div>
                    <IconButton onClick={handleOpenSelectModal} aria-label="edit" size="small" sx={{ marginLeft: 1 }}>
                        <EditIcon fontSize="small" />
                    </IconButton>
                </Grid>

                <Grid>
                    <SelectPeriodoSazonal
                        prevValues={{
                            periodo_inicio: values.periodo_vendas_inicio,
                            periodo_fim: values.periodo_vendas_fim,
                            sazonalidade_inicio: values.sazonalidade_inicio,
                            sazonalidade_fim: values.sazonalidade_fim
                        }}
                        onChange={(values: SelectPeriodoVendasValues) => {
                            onChange({
                                periodo_vendas_inicio: values.periodo_inicio,
                                periodo_vendas_fim: values.periodo_fim,
                                sazonalidade_inicio: values.sazonalidade_inicio,
                                sazonalidade_fim: values.sazonalidade_fim,
                            })
                        }} />
                </Grid>

                <Grid display="flex" alignItems="center">
                    <div>
                        <Typography fontSize={12}>Sugerir quantidades para</Typography>
                        <Typography fontSize={18}>{values.qtdSuggestion} dia(s)</Typography>
                    </div>
                    <IconButton onClick={() => setOpenModalQtdSugestion(true)} aria-label="edit" size="small" sx={{ marginLeft: 1 }}>
                        <EditIcon fontSize="small" />
                    </IconButton>
                </Grid>

            </Grid>

            <Grid container display="flex" mt={1} spacing={2}>

                <Grid size={{ xs: 12, md: 6 }}>
                    <TextField
                        fullWidth
                        label="Pesquisar"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchTerm(e.target.value)}
                        slotProps={{
                            input: { endAdornment: <SearchIcon /> }
                        }}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 2 }}>
                    <SelectQuery
                        query="estoque/pesquisar-departamentos"
                        type="field"
                        label="Departamento"
                        titleModal="Selecionar departamento"
                        emptyLabel="Todos"
                        returnOnlyId={false}
                        multiple={true}
                        defaultValue={values.departamentos?.map(i => ({ id: i.id, nome: i.nome }))}
                        onChange={(values) => {
                            onChange({ departamentos: values });
                        }}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 2 }}>
                    <SelectQuery
                        query="estoque/pesquisar-setores"
                        label="Setor"
                        type="field"
                        titleModal="Selecionar setor"
                        emptyLabel="Todos"
                        multiple={true}
                        onChange={(values) => {
                            onChange({ setores: values });
                        }}
                    />
                </Grid>

                <Grid size={{ xs: 12, md: 2 }}>
                    <SelectQuery
                        query="estoque/configuracoes/pesquisar-sazonalidades-vendas"
                        label="Sazonalidade"
                        type="field"
                        titleModal="Selecionar sazonalidade"
                        emptyLabel="Todas"
                        multiple={true}
                        onChange={(values) => {
                            onChange({ sazonalidades_ids: values });
                        }}
                    />
                </Grid>
            </Grid>

            <Divider sx={{ marginY: 2 }} />

            <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography fontSize={12} mt={1} mb={1}>Filtros pré definidos</Typography>
                    {
                        filtrosPreDefinidos.map((i: FiltrosPreDefinidos, index: number) =>
                            <Chip
                                key={index}
                                label={i.nome}
                                style={{ marginRight: 4 }}
                                onClick={() => handleSelectPreFilter(i)}
                                color={values.predSelecionado?.nome === i.nome ? 'primary' : 'default'}
                                variant={values.predSelecionado?.nome === i.nome ? 'filled' : 'outlined'}
                            />
                        )
                    }
                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography fontSize={12} mt={1} mb={1}>Mostrar items</Typography>
                    <Stack direction="row" spacing={2}>
                        <FormControlLabel
                            label="Sem estoque na origem"
                            control={
                                <Switch
                                    size="small"
                                    checked={values.mostrar_itens_sem_estoque_origem}
                                    onChange={(e) => {
                                        onChange({ mostrar_itens_sem_estoque_origem: e.target.checked });
                                    }}
                                />
                            }
                            componentsProps={{
                                typography: {
                                    variant: "subtitle2"
                                }
                            }}
                        />
                    </Stack>
                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>
                    <Typography fontSize={12} mt={1} mb={1}>Filtrar por nível de estoque</Typography>
                    <Box>
                        {
                            niveisEstoqueOptions.map((item, index) => {
                                const isChecked = values.niveis_estoque.includes(item.value)
                                return (
                                    <FormControlLabel
                                        key={index}
                                        label={item.label}
                                        control={<Checkbox checked={isChecked} size="small" />}
                                        onChange={() => handleSelectNiveisEstoque(item.value)}
                                    />
                                )
                            })
                        }
                    </Box>
                </Grid>
            </Grid>

            <ModalOrigemDestino
                {...{ values }}
                isFirstFilled={userPerfilComLoja?.loja ? false : true}
                open={openSelectModal}
                handleClose={() => {
                    setOpenSelectModal(false)
                }}
                onChangeOrigem={(value) => {
                    onChange({ origem: value })
                }}
                onChangeDestino={(value) => {
                    onChange({ destino: value })
                }}
            />

            <ModalSelectQtdSugestion
                open={openModalQtdSugestion}
                qtdValue={values.qtdSuggestion}
                handleClose={() => setOpenModalQtdSugestion(false)}
                onSubmit={(value) => onChange({ qtdSuggestion: value })}
            />
        </>
    );
}



interface FiltrosProps {
    values: IFilters
    onChange: (arg: any) => void
}